import type { SavedAccount } from '../types/profile'

const KEY = 'saved_accounts'

export function loadSavedAccounts(): SavedAccount[] {
  if (typeof localStorage === 'undefined') return []
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw) as unknown
    return Array.isArray(parsed) ? (parsed as SavedAccount[]) : []
  } catch {
    return []
  }
}

export function upsertSavedAccount(account: SavedAccount): SavedAccount[] {
  if (typeof localStorage === 'undefined') return [account]
  const list = loadSavedAccounts().filter((a) => a.user_id !== account.user_id)
  const next = [account, ...list].slice(0, 8)
  localStorage.setItem(KEY, JSON.stringify(next))
  return next
}

export function removeSavedAccount(userId: string): SavedAccount[] {
  if (typeof localStorage === 'undefined') return []
  const next = loadSavedAccounts().filter((a) => a.user_id !== userId)
  localStorage.setItem(KEY, JSON.stringify(next))
  return next
}
